// extracted by mini-css-extract-plugin
export default {"empty":"EmptyState_empty__K91vh","icon":"EmptyState_icon__kB5Lb","title":"EmptyState_title__C-UkF","description":"EmptyState_description__0FudI","action":"EmptyState_action__ZoUuB"};